// extracted by mini-css-extract-plugin
module.exports = {"compSource":"index-modulecompSource-3FW4e","compSourceList":"index-modulecompSourceList-Z78z4","materialPanelBox":"index-modulematerialPanelBox-iNPl0"};